import React from 'react';

import PropTypes from 'prop-types';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import styled from 'styled-components';
import { StyledTooltip } from 'styles/common';

import { Typography5, Typography9 } from 'uiToolkit/Typography';

const MeshDonutChart = ({ data, noGap = false, width = '75%' }) => (
  <ResponsiveContainer width={width} aspect={1}>
    <PieChart>
      <Pie data={data} dataKey="count" innerRadius="60%" outerRadius="100%">
        {data.map((obj) => (
          <Cell strokeWidth={noGap ? 0 : 2} fill={obj.color} />
        ))}
      </Pie>
    </PieChart>
  </ResponsiveContainer>
);

const CircularLabelWrapper = styled.div`
  height: 55px;
  width: 55px;
  border-radius: 50%;
  box-shadow: 3px 4px 5px 0px #0000001c;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
`;

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (props) => {
  const { cx, cy, count, name, percentage, outerRadius, midAngle } = props;

  const posx = cx + outerRadius * 1.1 * Math.cos(-midAngle * RADIAN) - 30;
  const posy = cy + outerRadius * 1.1 * Math.sin(-midAngle * RADIAN) - 30;

  return (
    <g>
      <foreignObject className="node" x={posx} y={posy} width="60" height="60">
        <StyledTooltip title={`Applauded ${name.toLowerCase()} ${count} times (${percentage}%)`}>
          <CircularLabelWrapper>
            <Typography5>{percentage}%</Typography5>
            <Typography9>{name}</Typography9>
          </CircularLabelWrapper>
        </StyledTooltip>
      </foreignObject>
    </g>
  );
};

export const MeshDonutChart2 = ({ data, noGap = false }) => (
  <ResponsiveContainer width="100%" height="100%" aspect={1}>
    <PieChart>
      <Pie
        data={data}
        dataKey="count"
        innerRadius="38%"
        outerRadius="70%"
        label={renderCustomizedLabel}
        cx="50%"
        cy="50%"
        startAngle={90}
        endAngle={450}
      >
        {data.map((obj) => (
          <Cell strokeWidth={noGap ? 0 : 2} fill={obj.color} />
        ))}
      </Pie>
    </PieChart>
  </ResponsiveContainer>
);

MeshDonutChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.oneOfType([PropTypes.number]).isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MeshDonutChart;
